import styled from "@emotion/styled";

export const TextIcon = styled.span`
  display: inline-block;

  margin-right: 0.25rem;
  width: 0.875rem;

  color: currentColor;

  text-align: center;

  font-weight: 700;
  font-size: 1.25rem;
`;
